import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@src/core/services';
import JsBarcode from 'jsbarcode';

/**
 * Компонент для отображения штрихкода
 * @param { string } value - значение штрихкода
 * @param { JsBarcode.Options } options - настройки штрихкода
 *
 * @see https://github.com/lindell/JsBarcode
 */
@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarcodeComponent implements OnInit {
  private readonly alertService = inject(AlertService);
  private readonly translateService = inject(TranslateService);

  @Input() value: string = '';
  @Input() options?: JsBarcode.Options;

  ngOnInit(): void {
    JsBarcode('#barcode', this.value, { ...this.options, valid: isValid => this.safeRender(isValid) });
  }

  safeRender(isValid: boolean) {
    if (!isValid) {
      JsBarcode('#barcode', this.value, { valid: isValid => this.checkValidation(isValid) });
    }
  }

  checkValidation(isValid: boolean) {
    if (!isValid) {
      this.alertService.error(this.translateService.instant('components.barcode.alerts.errors.barcodeInvalid'));
    }
  }
}
